import React, { Component } from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'
import * as styles from './search.module.css'

export default class Search extends Component {

  render() {

    const categorys = ["セクシー女優(乳)","セクシー女優(尻)","レビュー記事(乳)","レビュー記事(尻)","レビュー記事(他)","グラビアアイドル"]
    const tags = ["パイズリ","腿コキ","潮吹き","元グラドル","メートル尻","腹肉","オホ声","消えた逸材","放尿","淫語","顔面騎乗","イメージビデオ","元アスリート","無修正","尻コキ","マン毛","デカ乳輪"]
    const mtags = ["まぐろ物産","かつお物産","デジタルアーク","ワンズファクトリー","MARRION","WEEKENDER","Fitch","マドンナ","ドグマ","本中","JAMS","ルナティックス"]

    return (
      <div className={styles.search}>
        <p className='heading' style={{ marginBottom: `20px` }}>レビュー記事検索</p>
        <div className={styles.search_contents}>
          <p className={styles.heading}>カテゴリー</p>
          <div className={styles.search_subcontents}>
            {(categorys || []).map((category, idx) => (
              <Link to={`/category/${kebabCase(category)}/`}>
                <div className={styles.category} key={idx}><span>{category}</span></div>
              </Link>
            ))}
          </div>
          <p className={styles.heading}>タグ（フェチ）</p>
          <div className={styles.search_subcontents}>
            {(tags || []).map((tag, idx) => (
              <Link to={`/tags/${kebabCase(tag)}/`}>
                <div className={styles.tag} key={idx}><span>{tag}</span></div>
              </Link>
            ))}
          </div>
          <p className={styles.heading}>タグ（メーカー）</p>
          <div className={styles.search_subcontents}>
            {(mtags || []).map((tag, idx) => (
              <Link to={`/tags/${kebabCase(tag)}/`}>
                <div className={styles.tag} key={idx}><span>{tag}</span></div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    )
  }
}